<template>
    <div class="examineDetail">
        <div class="back" @click="back"> <a-button type="primary"><i class="iconfont icon-fanhuiicon mr5"></i>
                返回</a-button></div>
        <div class="detail_main">
            <div class="drawer_title">车辆信息</div>
            <div class="mt24">
                <table :class="[pageType != 'edit' ? 'border_table' : '']">
                    <tr>
                        <td>
                            <div class="box">
                                <span class="table_title">测试车辆信息：</span>
                                <a-select @change="selectChange" v-model:value="form.carId" v-if="pageType == 'edit'"
                                    placeholder="请输入">
                                    <a-select-option v-for="item in selectData" :key="item.id" :value="item.id">
                                        {{ item.frameNum + "/" + item.testCarNum || "无" }}
                                    </a-select-option>
                                </a-select>
                                <span class="table_content" v-else>{{ carMessage(form.carId) }}</span>
                            </div>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <div class="box">
                                <span class="table_title">测试车辆类型：</span>
                                <a-input v-model:value="carForm.carType" :disabled="true" v-if="pageType == 'edit'"
                                    placeholder="请输入" />
                                <span class="table_content" v-else>
                                    {{ getSingleTypeValue(appStore.SysDictVOList, 'carInfo' + 'category' +
                                    carForm.carType) }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <div class="box">
                                <span class="table_title">监管装置：</span>
                                <a-input v-model:value="computedModel" :disabled="true" v-if="pageType == 'edit'"
                                    placeholder="请输入" />
                                <span class="table_content" v-else>{{ carForm.bindMonitorDevice == '0' ? '未安装' : '已安装'
                                }}</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="box">
                                <span class="table_title">能耗类型： </span>

                                <a-input v-model:value="carForm.energyType" :disabled="true" v-if="pageType == 'edit'"
                                    placeholder="请输入" />
                                <span class="table_content" v-else>{{ carForm.energyType }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="box">
                                <span class="table_title">最大容量：</span>
                                <a-input v-model:value="carForm.maxCapacity" :disabled="true" v-if="pageType == 'edit'"
                                    placeholder="请输入" />
                                <span class="table_content" v-else>{{ carForm.maxCapacity }}</span>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="drawer_title mt24">测试信息</div>
            <div class="mt24">
                <table :class="[pageType != 'edit' ? 'border_table' : '']">
                    <tr>
                        <td>
                            <div class="box">
                                <span class="table_title">测试类型：</span>
                                <a-select @change="selectTestChange" v-model:value="testForm.qualificationId"
                                    v-if="pageType == 'edit'" placeholder="请输入">
                                    <a-select-option v-for="item in carForm.carQualificationInfos" :key="item.id"
                                        :value="item.id">
                                        {{
                                            getSingleTypeValue(appStore.SysDictVOList, dataType + "category" +
                                        item.category)
                                        }}
                                        <!--  getSingleTypeValue(appStore.SysDictVOList, dataType + "category" + item.category) -->
                                    </a-select-option>
                                </a-select>

                                <span class="table_content" v-else>{{ testTypeMethod(testForm.testType) }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="box">
                                <span class="table_title">测试区域：</span>
                                <a-select @change="selectAreaChange" v-model:value="testForm.testZoneNames"
                                    v-if="pageType == 'edit'" placeholder="请输入">
                                    <a-select-option v-for="item in selectAreaData" :key="item.id" :value="item.name">
                                        {{ item.name }}
                                    </a-select-option>
                                </a-select>

                                <span class="table_content" v-else>{{ testForm.testZoneNames }}</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="box">
                                <span class="table_title">选择日期：</span>
                                <!-- <a-date-picker v-model:value="testTime" :disabled-date="disabledDate"
                                    v-if="pageType == 'edit'" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" /> -->
                                <a-range-picker v-model:value="testTime" show-time v-if="pageType == 'edit'"
                                    format="YYYY-MM-DD HH:mm" valueFormat="YYYY-MM-DD HH:mm" />



                                <span class="table_content" v-else>
                                    {{ testTime.length !== 0 ? testTime[0] + ' ~ ' + testTime[1] : '' }}
                                </span>
                            </div>
                        </td>
                        <!-- <td>
                            <div class="box">
                                <span class="table_title">选择时段：</span>
                                <a-time-range-picker @change="timeRangeChange" v-model:value="timeFrame"
                                    v-if="pageType == 'edit'" format="HH:mm" valueFormat="HH:mm" />
                                <span class="table_content" v-else>
                                    {{ timeFrame.length == 0 ? '' : timeFrame[0] + '-' + timeFrame[1] }}
                                </span>
                            </div>
                        </td> -->

                        <td>
                            <div class="box">
                                <span class="table_title">是否需要预约：</span>
                                <a-select v-model:value="reservation" @change="reservationChange" placeholder="请选择"
                                    v-if="pageType == 'edit'">
                                    <a-select-option :value="1">是</a-select-option>
                                    <a-select-option :value="0">否</a-select-option>
                                </a-select>
                                <span class="table_content" v-else>
                                    {{ reservation === 0 ? '否' : reservation === 1 ? '是' : '' }}
                                </span>
                            </div>
                        </td>

                    </tr>
                  <tr v-if="pageType !== 'edit'">
                    <td>
                      <div class="box">
                        <span class="table_title">实际测试时间：</span>
                        <span class="table_content" v-if="testForm.actualTimeStart && testForm.actualTimeEnd">{{ testForm.actualTimeStart + ' ~ ' + testForm.actualTimeEnd }}</span>
                        <span class="table_content" v-else-if="testForm.actualTimeStart">{{ testForm.actualTimeStart + ' ~ 暂无结束时间' }}</span>
                        <span class="table_content" v-else-if="testForm.actualTimeEnd">{{ '暂无开始时间 ~ ' + testForm.actualTimeEnd }}</span>
                        <span class="table_content" v-else>-</span>
                      </div>
                    </td>
                    <td>
                      <div class="box">
                        <span class="table_title">实际测试里程：</span>
                        <span class="table_content">{{ testForm.accumulatedMileage ? testForm.accumulatedMileage : '-'}} km</span>
                      </div>
                    </td>
                  </tr>
                </table>
            </div>
            <div>
                <table :style="pageType != 'edit' ? { marginTop: '20px' } : {}"
                    :class="[pageType != 'edit' ? 'border_table' : '']">
                    <!-- <td>
                            <div class="box">
                            <span class="table_title">测试套路： </span>
                            <a-select v-model:value="form.status"  v-if="pageType=='edit'" placeholder="请输入">
                                <a-select-option :value="0">预约式道路</a-select-option>
                            </a-select>
                            <span class="table_content" v-else>预约式道路</span>
                       
                            </div>
                    </td> -->

                    <!-- <tr style="margin-top: 20px;">
                        <td>
                            <div class="box">
                                <span class="table_title">是否需要预约：</span>
                                <a-select v-model:value="reservation" @change="reservationChange" placeholder="请选择"
                                    v-if="pageType == 'edit'">
                                    <a-select-option :value="1">是</a-select-option>
                                    <a-select-option :value="0">否</a-select-option>
                                </a-select>
                                <span class="table_content" v-else>
                                    {{ reservation === 0 ? '否' : reservation === 1 ? '是' : '' }}
                                </span>
                            </div>
                        </td>
                        <td></td>
                    </tr> -->



                </table>
            </div>
            <div class="mt24 line_map">

                <detailMap :oldValue="roadValue" :roadList="roadList" :type="pageType" :carForm="carForm"
                    :mapTitle="mapTitle" ref="detailMapRef"></detailMap>
            </div>
            <div class="drawer_title mt24">驾驶员/安全员信息</div>
            <div class="mt24">
                <table :class="[pageType != 'edit' ? 'border_table' : '']">
                    <tr>
                        <td class="thirdly">
                            <div class="box">
                                <span class="table_title">驾驶员姓名：</span>
                                <a-select v-model:value="driverForm.name" @change="driverChange"
                                    v-if="pageType == 'edit'" placeholder="请选择">
                                    <a-select-option v-for="item in driverData" :key="item.id" :value="item.id">
                                        {{ item.name }}
                                    </a-select-option>
                                </a-select>
                                <span class="table_content" v-else>{{ driverForm.name }}</span>
                            </div>

                        </td>
                        <td class="thirdly">
                            <div class="box">
                                <span class="table_title">驾驶证号：</span>
                                <a-input v-model:value="driverForm.driverNum" :disabled="true" v-if="pageType == 'edit'"
                                    placeholder="请输入" />
                                <span class="table_content" v-else>{{ driverForm.driverNum }}</span>
                            </div>
                        </td>
                        <td class="thirdly">
                            <div class="box">
                                <span class="table_title">联系电话：</span>
                                <a-input v-model:value="driverForm.phoneNum" :disabled="true" v-if="pageType == 'edit'"
                                    placeholder="请输入" />
                                <span class="table_content" v-else>{{ driverForm.phoneNum }}</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="thirdly">
                            <div class="box">
                                <span class="table_title">安全员姓名：</span>
                                <a-select v-model:value="securityForm.name" @change="securityChange" placeholder="请选择"
                                    v-if="pageType == 'edit'">
                                    <a-select-option v-for="item in securityData" :key="item.id" :value="item.id">
                                        {{ item.name }}
                                    </a-select-option>
                                </a-select>
                                <span class="table_content" v-else>{{ securityForm.name }}</span>
                            </div>
                        </td>
                        <td class="thirdly">
                            <div class="box">
                                <span class="table_title">身份证号：</span>
                                <a-input v-model:value="securityForm.certificateNum" :disabled="true"
                                    v-if="pageType == 'edit'" placeholder="请输入" />
                                <span class="table_content" v-else>{{ securityForm.certificateNum }}</span>
                            </div>
                        </td>
                        <td class="thirdly">
                            <div class="box">
                                <span class="table_title">联系电话：</span>
                                <a-input v-model:value="securityForm.phoneNum" :disabled="true"
                                    v-if="pageType == 'edit'" placeholder="请输入" />
                                <span class="table_content" v-else>{{ securityForm.phoneNum }}</span>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div v-if="pageType != 'edit'" class="drawer_title mt24">审批结果</div>
            <div v-if="pageType != 'edit'" class="mt24">
                <table :class="[pageType != 'edit' ? 'border_table' : '']">
                    <tr>
                        <td class="name fourthly">
                            审批时间
                        </td>
                        <td class="name fourthly">
                            审批人
                        </td>
                        <td class="name fourthly">
                            审批结果
                        </td>
                        <td class="name fourthly">
                            审批意见
                        </td>
                    </tr>
                    <tr>
                        <td class="fourthly">{{ testForm.approvalTime ? testForm.approvalTime : '-' }}</td>
                        <td class="fourthly">{{ testForm.approvalPerson ? testForm.approvalPerson : '-' }}</td>
                        <td class="fourthly">
                            {{
                                testForm.approvalStatus ?
                                    testForm.approvalStatus == 0 ? '待审批' : testForm.approvalStatus == 1 ? '审批通过' :
                                        testForm.approvalStatus == 2 ? '审批不通过' : testForm.approvalStatus == 3 ? '无需审批' : '-'
                                    : '-'
                            }}
                        </td>
                        <td class="fourthly">{{ testForm.approvalMsg ? testForm.approvalMsg : '-' }}</td>
                    </tr>

                </table>
            </div>

            <div class="mt50 botmBtn" v-if="pageType == 'edit'">
                <a-button type="primary" ghost @click="cancel">取消</a-button>
                <a-button type="primary" class="ml60" @click="confirm">确定</a-button>
            </div>

        </div>
    </div>
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import detailMap from './testDetailComponents/Map.vue'
import { getSingleTypeValue } from "@/utils/matchDic";
import { getQualificationCarList, getZoneListByQualification, getPersonListByQualificationId, getTestZoneDetailsByCondition, checkCarChangeApply, save, checkTestTaskTimeScope, detailCarInfoById, detailTestTaskZoneInfoById, detailTestTaskPersonInfoById } from '@/api/test/testDetail.js'
import { message } from 'ant-design-vue'
import moment from 'moment';
import useAppStore from "@/store/modules/app";
const appStore = useAppStore();
/**
 * 地址栏参数说明
 * type:'0',//  0 查看详情模式  ，1编辑模式
 * from:""  //来源 0 testManage/task  ，1  testManage/reservation   返回按钮需返回到具体的对应页面   
 */

const router = useRouter()
const route = useRoute()


const dataType = "testType";

const activeKeys = ref(0)

const pageType = route.query.type;  //页面类型  view 预览、详情  ,  edit 新增、编辑

const form = ref({
    carId: undefined,
    phone: ""
})

const carForm = ref({
    carType: '',
    bindMonitorDevice: '',
    energyType: '',
    maxCapacity: '',
})

const testForm = ref({
    qualificationId: undefined,
    testType: "",
    testStartTime: "",
    testEndTime: "",
    testZoneNames: undefined,
})

const testTime = ref([])
const timeFrame = ref([])

const timeRangeChange = value => {
    console.log(value);
}

const driverForm = ref({
    name: undefined,
    driverNum: '',
    phoneNum: '',
})

const securityForm = ref({
    name: undefined,
    certificateNum: '',
    phoneNum: '',
})

const disabledDate = current => {
    // Can not select days before today and today
    return current <= moment().subtract(1, "days");
    // current <= moment().subtract(1, "days") || current >= moment().endOf('day'); // 只能选择当日的日期
    // current >= moment().endOf('day')        //只能选择当天之前的日期
    // current <= moment().subtract(1, "days") //只能选择当天之后的日期
};


// 是否需要预约
const reservation = ref(undefined)

const selectData = ref([]);
const getSelectData = () => {

    getQualificationCarList().then((res) => {
        console.log(res);
        if (res.code === 200) {
            selectData.value = res.data;
        }
    });
};
const roadList = ref([]);
const roadValue = ref([]);

// 测试车辆信息
const selectChange = (value) => {
    // console.log(value);
    reservation.value = undefined
    areaFirterID.value = ''
    selectAreaData.value = []

    driverData.value = []
    securityData.value = []

    driverForm.value = { name: undefined, driverNum: '', phoneNum: '', }
    securityForm.value = { name: undefined, certificateNum: '', phoneNum: '', }

    if (roadList.value.length != 0) {
        detailMapRef.value.clearMap()
        detailMapRef.value.polylines = [];
        roadList.value = []
        roadValue.value = []
    }
    testForm.value = {
        qualificationId: undefined,
        testType: "",
        testStartTime: "",
        testEndTime: "",
        testZoneNames: undefined,
    }
    let copySelectData = JSON.parse(JSON.stringify(selectData.value))
    let res = copySelectData.find((item) => item.id === value);
    console.log(res);
    res.carType = getSingleTypeValue(appStore.SysDictVOList, 'carInfo' + 'category' + res.carType)
    carForm.value = res
    console.log(carForm.value);
};

const computedModel = computed({
    get() {
        // 根据条件判断返回不同的值
        return carForm.value.bindMonitorDevice == '0' ? '未安装' : '已安装';
    },
    set(value) {
        carForm.value.bindMonitorDevice = value;
    }
});

const selectAreaData = ref([])

// 测试类型
const selectTestChange = (value) => {
    console.log(value);

    reservation.value = undefined
    areaFirterID.value = ''
    selectAreaData.value = []

    driverData.value = []
    securityData.value = []

    driverForm.value = { name: undefined, driverNum: '', phoneNum: '', }
    securityForm.value = { name: undefined, certificateNum: '', phoneNum: '', }

    if (roadList.value.length != 0) {
        detailMapRef.value.clearMap()
        detailMapRef.value.polylines = [];
        roadList.value = []
        roadValue.value = []
    }
    let res = carForm.value.carQualificationInfos.find((item) => item.id === value);
    console.log(res);
    testForm.value = res
    testForm.value.qualificationId = res.id
    testForm.value.testType = res.category
    // 测试区域
    getZoneListByQualification(testForm.value.qualificationId, testForm.value.testType).then(res => {
        console.log(res);
        if (res.code === 200) {
            selectAreaData.value = res.data
        }
    })
    // 驾驶员 安全员 信息
    getPersonListByQualificationIdData(testForm.value.qualificationId, 'driver')
    getPersonListByQualificationIdData(testForm.value.qualificationId, 'security')

    testForm.value.testZoneNames = undefined

}


const areaFirterID = ref('')
const areaFirterName = ref('')
// 测试区域
const selectAreaChange = (value) => {
    console.log(value);

    if (roadList.value.length != 0) {
        detailMapRef.value.clearMap()
        detailMapRef.value.polylines = [];
        roadList.value = []
        roadValue.value = []
    }
    reservation.value = undefined

    let info = selectAreaData.value.find((item) => item.name === value);
    console.log(info);
    areaFirterID.value = info.id
    areaFirterName.value = info.name
    // 过滤道路
    filterData({
        qualificationId: testForm.value.qualificationId, reservation: reservation.value, zoneIds: [info.id]
    })



    console.log(roadList.value);
}

// 筛选
const filterData = (data) => {
    getTestZoneDetailsByCondition(data).then(res => {
        console.log(res);
        if (res.code === 200) {
            res.data.forEach(item => {
                item.locationInfo = JSON.parse(item.locationInfo);
                console.log(item.locationInfo);
                // item.locationInfo = item.locationInfo.map(i => {
                //     return i.map(Number)
                // })
            })
            roadList.value = res.data
            roadValue.value = roadList.value
        }
    })
}

const driverData = ref([])
const securityData = ref([])
const getPersonListByQualificationIdData = (qualificationId, personType) => {
    getPersonListByQualificationId(qualificationId, personType).then(res => {
        console.log(res);
        if (res.code === 200) {
            if (personType === 'driver') {
                driverData.value = res.data
            } else {
                securityData.value = res.data
            }
        }
    })
}
const driverChange = value => {
    console.log(value)
    let res = driverData.value.find((item) => item.id === value);
    console.log(res);
    driverForm.value = res
};
const securityChange = value => {
    console.log(value)
    let res = securityData.value.find((item) => item.id === value);
    console.log(res);
    securityForm.value = res
};
const mapTitle = ref('')
// 是否需要预约
const reservationChange = value => {
    console.log(value);
    if (value == 0) {
        mapTitle.value = '非预约式道路'
    } else {
        mapTitle.value = '预约式道路'
    }
    if (testForm.value.qualificationId) {

        if (roadList.value.length != 0) {
            detailMapRef.value.clearMap()
            detailMapRef.value.polylines = [];
            roadList.value = []
            roadValue.value = []
        }

        filterData({
            qualificationId: testForm.value.qualificationId, reservation: value, zoneIds: [areaFirterID.value]
        })
    }
}


//from:""  //来源 0 testManage/task  ，1  testManage/reservation   返回按钮需返回到具体的对应页面   
function back() {
    if (route.query.from == 0) {
        router.push('/testManage/task')
    } else if (route.query.from == 1) {
        router.push('/testManage/reservation')
    }

}


const cancel = () => {
    router.push('/testManage/task')
}


const detailMapRef = ref(null)
const confirm = async () => {
    console.log('选中的路线id', detailMapRef.value.choosed)
    let copyDetailMap = JSON.parse(JSON.stringify(detailMapRef.value.choosed))
    let copyRoadList = JSON.parse(JSON.stringify(roadList.value))

    let taskPersonRels = []
    taskPersonRels.push(
        {
            personId: driverForm.value.id,
            personName: driverForm.value.name,
            taskPersonType: "driver"
        },
        {
            personId: securityForm.value.id,
            personName: securityForm.value.name,
            taskPersonType: "security"
        },
    )

    let taskZoneRels = []

    let arr = copyRoadList.filter(item => copyDetailMap.indexOf(item.id) > -1)

    console.log(arr);
    arr.forEach(item => {
        taskZoneRels.push({
            zoneDetailId: item.id,
            zoneId: areaFirterID.value,
            zoneName: areaFirterName.value,
            zoneType: item.category,
            zoneDetailName: item.name
        })
    })

    let startTime = testTime.value[0]
    let endTime = testTime.value[1]


    // const testTime = ref('')
    // const timeFrame = ref([])

    let timeData = {
        carId: form.value.carId,
        endTime: endTime,
        qualificationId: testForm.value.qualificationId,
        startTime: startTime
    }

    let data = {
        carId: form.value.carId,
        endTime: endTime,
        reservation: reservation.value,
        qualificationId: testForm.value.qualificationId,
        startTime: startTime,
        taskPersonRels: taskPersonRels,
        taskZoneRels: taskZoneRels,
        testType: testForm.value.testType
    }
    console.log(testTime.value);
    
    console.log(data);
    
    if (!form.value.carId) {
        message.error('请选择测试车辆')
    } else if (!testForm.value.qualificationId) {
        message.error('请选择测试类型')
    } else if (!testForm.value.testZoneNames) {
        message.error('请选择测试区域')
    } else if (testTime.value.length == 0) {
        message.error('请选择日期')
    }
    // else if (timeFrame.value.length == 0) {
    //     message.error('请选择时段')
    // } 
    else if (reservation.value === undefined) {
        message.error('请选择是否需要预约')
    } else if (detailMapRef.value.choosed.length == 0) {
        message.error('请选择预约式道路')
    } else if (!driverForm.value.name) {
        message.error('请选择驾驶员姓名')
    } else if (!securityForm.value.name) {
        message.error('请选择安全员姓名')
    }

    else {
        try {
            let res = await checkCarChangeApply(form.value.carId)
            console.log(res);
            if (!res.data.result) {
                message.error(res.data.msg)
            } else {

                let info = await checkTestTaskTimeScope(timeData)
                console.log(info);

                if (!info.data.result) {
                    message.error(info.data.msg)
                } else {

                    let saveEvent = await save(data)
                    console.log(saveEvent);

                    if (saveEvent.code === 200) {
                        message.success('测试任务发起成功')
                        router.push('/testManage/task')
                    }
                }
            }
        } catch (err) {
            console.log(err);
        }
    }



}

const carMessage = value => {
    console.log(value);
    let res = selectData.value.find(item => item.id === value)
    console.log(res);

    return res ? res.frameNum + "/" + res.testCarNum : "无"
}

const testTypeMethod = value => {

    return getSingleTypeValue(appStore.SysDictVOList, dataType + "category" + testForm.value.testType)

}


onMounted(() => {
    activeKeys.value = Number(route.query.activeKey)
    getSelectData();
    // getData()


    // 详情
    if (route.query.id) {
        detailCarInfoById(route.query.id).then(res => {
            console.log(res);
            if (res.code === 200) {
                form.value.carId = res.data.id
                carForm.value = res.data
            }
        })
        detailTestTaskZoneInfoById(route.query.id).then(res => {
            console.log(res);
            if (res.code === 200) {
                if (res.data) {
                    testForm.value = res.data
                    testTime.value = res.data.startTime && res.data.endTime ? [res.data.startTime, res.data.endTime] : []
                    res.data.startTime ? timeFrame.value.push(res.data.startTime.split(' ')[1], res.data.endTime.split(' ')[1]) : []
                    reservation.value = res.data.reservation

                    res.data.zoneDetailInfos.forEach(item => {
                        item.locationInfo = JSON.parse(item.locationInfo);
                        // item.locationInfo = item.locationInfo.map(i => {
                        //     return i.map(Number)
                        // })
                    })
                    roadList.value = res.data.zoneDetailInfos
                    roadValue.value = roadList.value
                }
            }
        })
        detailTestTaskPersonInfoById(route.query.id).then(res => {
            console.log(res);
            if (res.code === 200) {

                res.data.driverPerson ? driverForm.value = res.data.driverPerson : {}
                res.data.securityPerson ? securityForm.value = res.data.securityPerson : {}
            }
        })
    }
})

</script>
<style lang="less" scoped>
.examineDetail {
    padding: 20px;
    // height: calc(100vh - 70px - 57px);
    background-color: #ffffff;

    .back {
        position: fixed;
        top: 93px;
        right: 50px
    }

    .detail_main {
        width: 66%;
        margin: 0 auto;

        .drawer_title {
            font-size: 14px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            color: #1D2129;
            position: relative;


            &::before {
                content: '';
                display: inline-block;
                width: 3px;
                height: 12px;
                background: #1E8EF2;
                border-radius: 10px;
                position: absolute;
                top: 2px;
                left: -12px;
            }
        }

        table {
            width: 100%;

            &.border_table {
                td {
                    border: 1px solid #E1E7EF;
                    padding: 17px 0 11px 28px;
                }
            }

            td {
                width: 50%;

                padding: 17px 0 17px 28px;
                font-size: 14px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                color: #636D7B;
                text-align: left;

                // border: 1px solid #E1E7EF;
                .box {
                    span:first-child {
                        display: inline-block;
                        width: 105px !important;
                        text-align: right;
                    }
                }
            }

            .name {
                background: #F6F8FA;
                padding: 11px 0 9px 28px;
                text-align: left;
                font-size: 14px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                color: #1D2129;
                border-left: 1px solid #F6F8FA;
                border-right: 1px solid #F6F8FA;
                border-top: none;
            }

            .thirdly {
                width: 33.3%;
            }

            .fourthly {
                width: 25%;
            }

            .table_action {
                font-size: 14px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                color: #186FF2;
            }
        }

        .table_title {
            color: rgba(99, 109, 123, 1);
        }

        .table_content {
            color: rgba(29, 33, 41, 1);
        }

        .line_map {
            height: 497px;
            background: #F6F8FA;

        }
    }

    .ant-input {
        width: calc(100% - 105px);
    }

    /deep/.ant-select {
        width: calc(100% - 105px);
    }

    .ant-picker {
        width: calc(100% - 105px);
    }
}

.mt50 {
    margin-top: 50px;
}

.botmBtn {
    text-align: center;

    .ant-btn {
        margin: 0 30px;
    }
}

/deep/.ant-input-disabled,
.ant-input[disabled] {
    background: #ddd;
}

/deep/.ant-picker.ant-picker-disabled {
    background: #ddd;
}
</style>
